export const GET_MOVIES = 'GET_MOVIES';
export const SELECT_MOVIE = 'SELECT_MOVIE';
export const GET_SUGGESTIONS = 'GET_SUGGESTIONS';
